/**
 * Milliseconds in one second. Time constants in this module are the frontend's
 * single source of truth for duration conversions. Mirrors `server/src/utils/time.ts`
 * to keep FE/BE math in lock-step.
 */
export const MS_PER_SECOND = 1000;

/** Milliseconds in one minute. */
export const MS_PER_MINUTE = 60 * MS_PER_SECOND;

/** Milliseconds in one hour. */
export const MS_PER_HOUR = 60 * MS_PER_MINUTE;

/** Milliseconds in one day. */
export const MS_PER_DAY = 24 * MS_PER_HOUR;

/** Milliseconds in one week. */
export const MS_PER_WEEK = 7 * MS_PER_DAY;

/** Converts hours to milliseconds. */
export function hoursToMs(hours: number): number {
  return hours * MS_PER_HOUR;
}

/** Converts minutes to milliseconds. */
export function minutesToMs(minutes: number): number {
  return minutes * MS_PER_MINUTE;
}

/** Converts days to milliseconds. */
export function daysToMs(days: number): number {
  return days * MS_PER_DAY;
}

/** Converts weeks to milliseconds. */
export function weeksToMs(weeks: number): number {
  return weeks * MS_PER_WEEK;
}
